<template>
  <div id="MainReportsDashboard">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'MainReportsDashboard'
}
</script>

<style scoped>
</style>
